import dayjs from 'dayjs';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import useRouterFilters from 'hooks/useRouterFilters';

import { ENUMS, ORDERS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const NeedActionShipmentsList = () => {
	const defaultSort = useMemo(() => [{ id: 'createdAt', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'ID',
				accessor: 'ID',
				filterType: FilterType.number,
				width: 70,
				show: false,
				showCopyButton: true
			},
			{
				Header: 'companyID',
				accessor: 'companyId',
				filterType: FilterType.number,
				width: 70,
				show: false,
				showCopyButton: true
			},
			{
				Header: 'orderID',
				accessor: 'orderID',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true,
				show: false,
				showCopyButton: true
			},
			{
				Header: 'orderDate',
				accessor: 'createdDate',
				filterType: FilterType.date,
				width: 100,
				show: false,
				filterRemovable: false,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'clientName',
				accessor: 'clientName',
				filterType: FilterType.string,
				width: 100
			},
			{
				Header: 'clientCountry',
				accessor: 'clientCountry',
				filterType: FilterType.string,
				width: 100
			},
			{
				Header: 'aggrementType',
				accessor: 'aggrementType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.SHIPPING_PRICE_AGREEMENT_TYPE,
				width: 100,
				show: false
			},
			{
				Header: 'serviceType',
				accessor: 'serviceType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.DC_CONTRACT_SERVICE_TYPES,
				width: 100
			},
			{
				Header: 'pickupType',
				accessor: 'pickingType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.NEW_PICKUP_TYPES,
				width: 100
			},
			{
				Header: 'originCountry',
				accessor: 'originCountry',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY,
				width: 100
			},
			{
				Header: 'shipmentNumber',
				accessor: 'shipmentNumber',
				filterType: FilterType.string,
				renderCell: ListComponents.TRACKING_URL,
				width: 100
			},
			{
				Header: 'returnShipmentNumber',
				accessor: 'returnShipmentNumber',
				filterType: FilterType.string,
				width: 100
			},
			{
				Header: 'salesChannel',
				accessor: 'salesChannelName',
				filterType: FilterType.string,
				width: 100,
				renderCell: ListComponents.SALES_CHANNEL_LOGO,
				show: false
			},
			{
				Header: 'branchName',
				accessor: 'branchName',
				filterType: FilterType.string,
				width: 90,
				show: false
			},
			{
				Header: 'warehouseName',
				accessor: 'warehouseName',
				filterType: FilterType.string,
				width: 90,
				show: false
			},
			{
				Header: 'brandName',
				accessor: 'storeName',
				filterType: FilterType.string,
				width: 100,
				show: false,
				renderCell: ListComponents.BRAND_LOGO
			},
			{
				Header: 'originCity',
				accessor: 'originCity',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'customerName',
				accessor: 'name',
				filterType: FilterType.string,
				width: 100,
				show: false
			},
			{
				Header: 'customerEmail',
				accessor: 'email',
				filterType: FilterType.string,
				width: 100,
				show: false
			},
			{
				Header: 'customerPhone',
				accessor: 'phone',
				filterType: FilterType.string,
				width: 100,
				renderCell: ListComponents.PHONE,
				show: false
			},
			{
				Header: 'customerAddress',
				accessor: 'address',
				filterType: FilterType.string,
				width: 130,
				show: false
			},
			{
				Header: 'destinationCountry',
				accessor: 'countryName',
				filterType: FilterType.string,
				width: 100
			},
			{
				Header: 'destinationCity',
				accessor: 'cityName',
				filterType: FilterType.string,
				width: 100,
				show: false
			},
			{
				Header: 'grandTotal',
				accessor: 'grandTotal',
				filterType: FilterType.float,
				width: 120,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'packageCount',
				accessor: 'packageCount',
				filterType: FilterType.number,
				width: 50,
				show: false
			},
			{
				Header: 'weight',
				accessor: 'weight',
				filterType: FilterType.number,
				width: 50,
				show: false
			},
			{
				Header: 'packageSize',
				accessor: 'maxPackageSize',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'couponCode',
				accessor: 'couponCode',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'skus',
				accessor: 'skuList',
				filterType: FilterType.string,
				width: 70,
				show: false
			},
			{
				Header: 'quantities',
				accessor: 'qtyList',
				filterType: FilterType.number,
				width: 70,
				show: false
			},
			{
				Header: 'lat',
				accessor: 'lat',
				filterType: FilterType.string,
				width: 70,
				show: false
			},
			{
				Header: 'lng',
				accessor: 'lng',
				filterType: FilterType.string,
				width: 70,
				show: false
			},
			{
				Header: 'drivingDistance',
				accessor: 'drivingDistance',
				filterType: FilterType.float,
				width: 70,
				show: false
			},
			{
				Header: 'district',
				accessor: 'district',
				filterType: FilterType.string,
				width: 100,
				show: false
			},
			{ Header: 'state', accessor: 'state', filterType: FilterType.string, width: 100, show: false },
			{
				Header: 'region',
				accessor: 'region',
				filterType: FilterType.string,
				width: 100,
				show: false
			},
			{
				Header: 'areaName',
				accessor: 'areaName',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'paymentMethod',
				accessor: 'paymentMethod',
				filterType: FilterType.string,
				width: 100
			},
			{
				Header: 'totalDue',
				accessor: 'totalDue',
				filterType: FilterType.float,
				width: 90,
				show: false,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'subtotal',
				accessor: 'subTotal',
				filterType: FilterType.float,
				width: 90,
				show: false,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'currency',
				accessor: 'currency',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CURRENCY,
				width: 70
			},
			{
				Header: 'lastComment',
				accessor: 'lastComment',
				filterType: FilterType.string,
				renderCell: ListComponents.LAST_COMMENT,
				width: 100,
				show: false
			},
			{
				Header: 'comments',
				accessor: 'comments',
				filterType: FilterType.string,
				width: 120,
				show: false
			},
			{
				Header: 'deliverySlot',
				accessor: 'deliverySlot',
				filterType: FilterType.string,
				width: 100,
				show: false
			},
			{
				Header: 'deliverySlotDate',
				accessor: 'deliverySlotDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATE,
				width: 100,
				show: false
			},
			{
				Header: 'deliveryName',
				accessor: 'deliveryName',
				filterType: FilterType.string,
				width: 90,
				renderCell: ListComponents.DC_LOGO,
				show: false
			},
			{
				Header: 'refundAmount',
				accessor: 'refundAmount',
				filterType: FilterType.number,
				show: false
			},
			{
				Header: 'dcReturnReason',
				accessor: 'dcReturnReason',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'customerReturnReason',
				accessor: 'returnReasonOptions',
				filterType: FilterType.string,
				width: 90,
				show: false
			},
			{
				Header: 'customerReturnComment',
				accessor: 'returnReason',
				filterType: FilterType.string,
				width: 90,
				show: false
			},
			{
				Header: 'returnType',
				accessor: 'returnType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.RETURN_TYPE,
				width: 90,
				show: false
			},
			{
				Header: 'isReturnShipment',
				accessor: 'isReturnShipment',
				filterType: FilterType.string,
				width: 90,
				show: false
			},
			{
				Header: 'returnDate',
				accessor: 'returnDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				width: 90,
				show: false
			},
			{
				Header: 'returnCreateDate',
				accessor: 'returnCreateDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				width: 90,
				show: false
			},
			{
				Header: 'shippingCost',
				accessor: 'OTOdeliveryFee',
				filterType: FilterType.number,
				width: 100,
				renderCell: ListComponents.CURRENCY,
				renderCellProps: {
					currency: 'shippingCurrency'
				}
			},
			{
				Header: 'shippingAmount',
				accessor: 'shippingAmount',
				filterType: FilterType.float,
				width: 120,
				renderCell: ListComponents.CURRENCY,
				show: false
			},
			{
				Header: 'driverPhone',
				accessor: 'driverPhone',
				filterType: FilterType.string,
				width: 100,
				renderCell: ListComponents.PHONE,
				show: false
			},
			{
				Header: 'driverName',
				accessor: 'driverName',
				filterType: FilterType.string,
				width: 100,
				show: false
			},
			{
				Header: 'onHoldComment',
				accessor: 'onHoldComment',
				filterType: FilterType.string,
				width: 105,
				show: false
			},
			{
				Header: 'onHoldReason',
				accessor: 'onHoldReason',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'cancelComment',
				accessor: 'cancelComment',
				filterType: FilterType.string,
				width: 90,
				show: false
			},
			{
				Header: 'cancelReason',
				accessor: 'cancelReason',
				filterType: FilterType.string,
				width: 90,
				show: false
			},
			{
				Header: 'failedDeliveryComment',
				accessor: 'failedDeliveryComment',
				filterType: FilterType.string,
				width: 90,
				show: false
			},
			{
				Header: 'failedReason',
				accessor: 'failedReason',
				filterType: FilterType.string,
				width: 90,
				show: false
			},
			{
				Header: 'awbPrinted',
				accessor: 'printed',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				width: 120,
				show: false
			},
			{
				Header: 'modifiedDate',
				accessor: 'modifiedAt',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				width: 80,
				show: false
			},
			{
				Header: 'modifiedBy',
				accessor: 'modifiedBy',
				filterType: FilterType.string,
				width: 80,
				show: false
			},
			{
				Header: 'CODStatus',
				accessor: 'CODStatus',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COD_STATUS,
				renderCell: ListComponents.STATUS,
				width: 100,
				show: false
			},
			{
				Header: 'returnStatus',
				accessor: 'returnApprovalStatus',
				renderCell: ListComponents.STATUS,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.RETURN_APPROVAL_STATUS,
				show: false
			},
			{
				Header: 'ecommerceStatus',
				accessor: 'ecomStatus',
				filterType: FilterType.string,
				renderCell: ListComponents.STATUS,
				show: false
			},
			{
				Header: 'addressConfirm',
				accessor: 'confirmationStatus',
				renderCell: ListComponents.SHIPMENT_STATUS,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CONFIRMATION_STATUS_LIST_ENUM,
				width: 100,
				show: false
			},
			{
				Header: 'codOrderConfirmation',
				accessor: 'orderConfirmation',
				renderCell: ListComponents.SHIPMENT_STATUS,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CONFIRMATION_STATUS_LIST_ENUM,
				width: 100,
				show: false
			},
			{
				Header: 'inventoryStatus',
				accessor: 'inventoryStatus',
				filterType: FilterType.string,
				width: 70,
				show: false
			},
			{
				Header: 'sortingStatus',
				accessor: 'sortingStatus',
				filterType: FilterType.string,
				width: 70,
				show: false
			},
			{
				Header: 'sortingBinId',
				accessor: 'sortingBinId',
				filterType: FilterType.string,
				width: 70,
				show: false
			},
			{
				Header: 'packingStatus',
				accessor: 'packingStatus',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.PACKING_STATUS,
				width: 100,
				show: false
			},
			{
				Header: 'pickerName',
				accessor: 'pickerName',
				filterType: FilterType.string,
				width: 90,
				show: false
			},
			{
				Header: 'waveId',
				accessor: 'waveID',
				filterType: FilterType.number,
				width: 100,
				show: false,
				showCopyButton: true
			},
			{
				Header: 'dispatchingUnit',
				accessor: 'palletNo',
				filterType: FilterType.number,
				width: 70,
				show: false
			},
			{
				Header: 'rating',
				accessor: 'rating',
				filterType: FilterType.number,
				show: false
			},
			{
				Header: 'shipmentRating',
				accessor: 'shipmentRating',
				filterType: FilterType.number,
				show: false
			},
			{
				Header: 'rateComment',
				accessor: 'rateComment',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'ratingFile',
				accessor: 'ratingFile',
				filterType: FilterType.string,
				renderCell: ListComponents.DOWNLOAD_FILE,
				show: false
			},
			{
				Header: 'shipmentCreationDate',
				accessor: 'shipmentCreationDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'deliveryDate',
				accessor: 'deliveryDate',
				filterType: FilterType.date,
				width: 100,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'preparationTime',
				accessor: 'preparationTime',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'ref1',
				accessor: 'ref1',
				filterType: FilterType.string,
				width: 90,
				show: false,
				renderCell: ListComponents.URL
			},
			{
				Header: 'OTODCSettingsId',
				accessor: 'OTODCSettingsId',
				filterType: FilterType.number,
				width: 90,
				show: false
			},
			{
				Header: 'returnDCSettingsId',
				accessor: 'returnDCSettingsId',
				filterType: FilterType.number,
				width: 90,
				show: false
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ALL_STATUSES,
				renderCell: ListComponents.SHIPMENT_STATUS,
				showOnMobile: true,
				width: 200
			}
		],
		[]
	);

	const defaultFilters = useMemo(
		() => [
			{
				column: columns.find((col) => col.accessor === 'createdDate'),
				action: FilterAction.between,
				value: {
					start: dayjs().subtract(1, 'day').endOf('day').toISOString(),
					end: dayjs().endOf('day').toISOString()
				}
			}
		],
		[]
	);

	const filtersFromRouter = useRouterFilters(columns);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.OPERATION_NEED_ACTION_SHIPMENT}
				columns={columns}
				fetchUrl={ORDERS.GET_OPERATION_NEED_ACTION_ORDER}
				defaultFilters={filtersFromRouter ?? defaultFilters}
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.ORDER}
				exportName="needActionShipments"
				infiniteScroll
				disableInfiniteScrollUp
			/>
		</TabTableContainer>
	);
};

export default NeedActionShipmentsList;
